import React, { useRef, useState } from "react";
import { BasicInfo } from "../components/Supplier/BasicInfo";
import {
  ChevronDownMicro,
  ChevronUpMicro,
  LocationMarkMini,
  loveOutlineMini,
} from "../assets/SvgIcons";
import { Link } from "react-router-dom";

/**
 * @author
 * @function SupplierDetails
 **/

const watches = [
  {
    name: "Dummy Watch 2",
    description: "Dummy Description 2",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Featured",
    additional_info: "Dummy Info 2",
    price: "$150",
    shipping: "$15",
    location: "US",
  },
  {
    name: "Dummy Watch 2",
    description: "Dummy Description 2",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Featured",
    additional_info: "Dummy Info 2",
    price: "$150",
    shipping: "$15",
    location: "US",
  },
  {
    name: "Dummy Watch 3",
    description: "Dummy Description 3",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Featured",
    additional_info: "Dummy Info 3",
    price: "$200",
    shipping: "$20",
    location: "US",
  },
];

const faqs = [
  {
    id: 350,
    question: "Legal Details",
    answer: (
      <div>
        <p className="text-lg font-semibold">Luxury Time Global</p>
        <br />
        <div className="grid grid-cols-2">
          <div>
            330 Montage Mountain Rd
            <br />
            Suite #102 <br />
            Moosic, PA 18507
            <br /> United States of America
          </div>
          <div>
            Tel.: [+1] 835-210-4858 <br />
            Mobile: [+1] 570-290-7407
          </div>
        </div>
      </div>
    ),
  },
];
export const SupplierDetails = (props) => {
  const [expanded, setExpanded] = useState(null);

  const toggleAccordion = (id) => {
    setExpanded(expanded === id ? null : id);
  };
  return (
    <>
      <BasicInfo />

      <section className="max-w-[720px] mx-auto lg:px-2 md:px-4 sm:px-4 ">
        <div className="mt-8 mb-8">
          <h2 className="lg:text-2xl md:text-xl sm:text-lg font-semibold mx-auto text-center">
            Featured Listings
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 items-center justify-center gap-4 w-full mb-12">
          {watches?.map((watch, index) => (
            <ProductCard key={index} watch={watch} />
          ))}
        </div>
        <div className="w-full  flex justify-center">
          <Link
            to={"/supplier/listings/1"}
            className=" text-center px-12 py-3 border rounded font-semibold bg-primarylight mb-24 mx-auto"
          >
            {" "}
            View all listing
          </Link>
        </div>

        {/* FAQ Accordion Section */}
        <div className="contact-faq-section py-2.5 border-y mb-28">
          <div className="accordion">
            {faqs?.map((faq) => (
              <div key={faq?.id} className="accordion-item ">
                <button
                  onClick={() => toggleAccordion(faq?.id)}
                  className="accordion-head w-full text-left p-4 lg:text-md md:text-md sm:text-sm font-medium flex justify-between items-center"
                >
                  <p>{faq?.question}</p>
                  {expanded === faq?.id ? ChevronUpMicro : ChevronDownMicro}
                </button>

                <div
                  className={` transition-all text-[14px] duration-300 ease-in-out overflow-hidden ${
                    expanded === faq?.id ? "max-h-[800px] " : "max-h-0 "
                  }`}
                >
                  <div
                    className={`  transition-opacity duration-300 ${
                      expanded === faq?.id ? "opacity-100" : "opacity-0"
                    }`}
                  >
                    <p className="accordion-body px-4 pb-4 text-gray-700 lg:text-sm md:text-sm sm:text-xs">
                      {faq?.answer}
                    </p>
                  </div>
                </div>

                {/* {expanded === faq?.id && (
                  <p className="accordion-body p-4 text-gray-700 lg:text-sm md:text-sm sm:text-xs">
                    {faq?.answer}
                  </p>
                )} */}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

const ProductCard = ({ watch }) => {
  const scrollRef = useRef(null);
  return (
    <div
      //
      className="border rounded-lg overflow-hidden "
    >
      <div className="relative">
        <div ref={scrollRef} className="flex overflow-x-scroll no-scrollbar">
          {watch?.image?.map((img, index) => {
            return (
              <img
                key={index}
                src={img}
                alt={watch.name}
                className=" object-cover shadow-sm"
              />
            );
          })}
        </div>
        <div className="w-full h-full absolute top-0  ">
          {/* IMG TOGGLE */}
          {/* <div className="w-full flex justify-between items-center px-1 py-3  absolute top-1/2 ">
            <button
              onClick={() => {
                scrollRef.current.scrollBy({
                  left:
                    -1 *
                    (scrollRef.current ? scrollRef.current.clientWidth : 0),
                  behavior: "smooth",
                });
              }}
              className="p-1 bg-[rgba(255,255,255,0.79)]  rounded-full flex items-center"
              aria-label="Previous page"
            >
              {ChevronLeft}
            </button>

            <button
              onClick={() => {
                scrollRef.current.scrollBy({
                  left:
                    1 * (scrollRef.current ? scrollRef.current.clientWidth : 0),
                  behavior: "smooth",
                });
              }}
              className="p-1 bg-[rgba(255,255,255,0.79)]  rounded-full flex items-center"
              aria-label="Next page"
            >
              {ChevronRight}
            </button>
          </div> */}
        </div>
      </div>
      <Link to={watch?.link}>
        <div className="p-4">
          <h2 className="text-[18px] text-[#5596B0] font-bold mb-1">
            {watch.name}
          </h2>
          <p className="text-gray-600 mb-2 text-[14px]">
            {watch.description?.slice(0, 34)}..
          </p>
          {/* <a
          href={watch.link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-blue-500 text-white text-center py-2 px-4 rounded hover:bg-blue-600 transition-colors duration-200"
        >
          View Listing
        </a> */}

          <div className="flex justify-between items-center gap-4 mt-2 text-[#5596B0]">
            <div>
              <strong className="text-[16px]">Price {watch?.price}</strong>
              {/* <p className="text-[13px] text-gray-400">
                + {watch?.shipping} for shipping
              </p> */}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};
